module.exports = __webpack_public_path__ + "static/media/loc3_img2.33ac6086.jpg";